(() => {
  const money = (cents, currency) => {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'CAD' }).format(Number(cents) / 100); }
    catch (e) { return '$' + (Number(cents) / 100).toFixed(2); }
  };

  const escapeHtml = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[char]));

  const syncProductMedia = (form, variant) => {
    if (!form || !variant) return;
    const mapNode = form.querySelector('[data-hh-variant-media]');
    if (!mapNode) return;
    let mediaMap = {};
    try { mediaMap = JSON.parse(mapNode.textContent); } catch (e) { return; }
    const targetId = mediaMap[String(variant.id)];
    if (!targetId) return;
    const target = document.getElementById(targetId);
    const gallery = target && target.closest('.hh-product__gallery');
    if (!target || !gallery) return;
    gallery.querySelectorAll('.hh-product__media').forEach((mediaNode) => mediaNode.classList.remove('hh-product__media--selected'));
    target.classList.add('hh-product__media--selected');
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => gallery.scrollTo({ left: 0, behavior })));
  };

  const updateVariantForm = (form, syncMedia = false) => {
    if (!form) return;
    const json = form.querySelector('[data-hh-variants]');
    const idInput = form.querySelector('[data-hh-variant-id]');
    if (!json || !idInput) return;

    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }

    const groups = [...form.querySelectorAll('[data-hh-option-group]')];
    const selectedOptions = groups.map((group) => {
      const checked = group.querySelector('[data-hh-option]:checked');
      return checked ? checked.value : null;
    });
    if (selectedOptions.some((value) => value === null)) return;

    const variant = variants.find((item) => Array.isArray(item.options) && item.options.every((value, index) => value === selectedOptions[index]));
    const button = form.querySelector('[data-hh-add]');
    const priceNode = document.querySelector('[data-hh-product-price]');

    if (!variant) {
      if (button) { button.disabled = true; button.textContent = 'UNAVAILABLE'; }
      return;
    }

    idInput.value = variant.id;
    if (priceNode) {
      const currency = priceNode.dataset.currency || 'CAD';
      const compare = Number(variant.compare_at_price || 0);
      const price = Number(variant.price || 0);
      priceNode.innerHTML = `${compare > price ? `<s>${money(compare, currency)}</s>` : ''}<strong>${money(price, currency)}</strong>`;
    }
    if (button) {
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
    }
    if (syncMedia) syncProductMedia(form, variant);
    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (target.matches('[data-hh-option]')) {
      const group = target.closest('[data-hh-option-group]');
      updateVariantForm(target.closest('form'), !!group && group.dataset.optionName === 'style');
    }
  });

  document.querySelectorAll('[data-hh-product-form]').forEach((form) => updateVariantForm(form));

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-hh-gallery-thumb]');
    if (!thumb) return;
    const target = document.querySelector(thumb.getAttribute('href'));
    if (target) { event.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  });

  const sort = document.querySelector('[data-hh-sort]');
  if (sort) sort.addEventListener('change', () => sort.form.submit());

  const header = document.querySelector('.hh-header');
  if (header && document.body.classList.contains('template-index')) {
    const announcement = document.querySelector('.hh-announcement');
    let ticking = false;
    const syncHeader = () => {
      const announcementHeight = announcement ? announcement.offsetHeight : 0;
      document.documentElement.style.setProperty('--hh-announcement-height', `${announcementHeight}px`);
      header.classList.toggle('hh-header--scrolled', window.scrollY > 40);
      ticking = false;
    };
    const requestSync = () => { if (ticking) return; ticking = true; window.requestAnimationFrame(syncHeader); };
    syncHeader();
    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync);
  }

  const menuDrawer = document.querySelector('[data-hh-menu-drawer]');
  const menuTrigger = document.querySelector('[data-hh-menu-open]');
  let menuLastFocus = null;
  const openMenu = () => {
    if (!menuDrawer) return;
    menuLastFocus = document.activeElement;
    menuDrawer.classList.add('is-open');
    menuDrawer.setAttribute('aria-hidden', 'false');
    if (menuTrigger) menuTrigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('hh-drawer-open');
    const close = menuDrawer.querySelector('[data-hh-menu-close]');
    if (close) close.focus();
  };
  const closeMenu = () => {
    if (!menuDrawer) return;
    menuDrawer.classList.remove('is-open');
    menuDrawer.setAttribute('aria-hidden', 'true');
    if (menuTrigger) menuTrigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('hh-drawer-open');
    if (menuLastFocus && typeof menuLastFocus.focus === 'function') menuLastFocus.focus();
  };

  const cartDrawer = document.querySelector('[data-hh-cart-drawer]');
  let cartRules = { freeShipping: 13000, teeProductIds: [], hoodieProductIds: [] };
  if (cartDrawer) {
    const rulesNode = cartDrawer.querySelector('[data-hh-cart-rules]');
    if (rulesNode) {
      try { cartRules = { ...cartRules, ...JSON.parse(rulesNode.textContent) }; } catch (e) {}
    }
  }
  const teeIds = new Set((cartRules.teeProductIds || []).map(Number));
  const hoodieIds = new Set((cartRules.hoodieProductIds || []).map(Number));
  let cartLastFocus = null;

  const updateCartCount = (cart) => {
    document.querySelectorAll('[data-hh-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    document.querySelectorAll('[data-hh-cart-drawer-count]').forEach((node) => { node.textContent = `(${cart.item_count})`; });
  };

  const renderCartItems = (cart) => {
    if (!cartDrawer) return;
    const node = cartDrawer.querySelector('[data-hh-cart-items]');
    if (!node) return;
    if (!cart.item_count) {
      node.innerHTML = '<div class="hh-cart-empty">YOUR CART IS EMPTY.<br><br><a href="/collections/menu-items">SHOP MENU ITEMS -</a></div>';
      return;
    }
    node.innerHTML = cart.items.map((item) => {
      const image = item.image ? `<a class="hh-cart-item__image" href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}"></a>` : '<div class="hh-cart-item__image"></div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="hh-cart-item__variant">${escapeHtml(item.variant_title)}</div>` : '';
      const linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;
      return `<article class="hh-cart-item" data-cart-key="${escapeHtml(item.key)}">
        ${image}
        <div class="hh-cart-item__info">
          <a class="hh-cart-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
          ${variant}
          <div class="hh-cart-item__qty">
            <button type="button" data-hh-cart-delta="-1" data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-hh-cart-delta="1" data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity}" aria-label="Increase quantity">+</button>
          </div>
          <button type="button" class="hh-cart-item__remove" data-hh-cart-remove data-key="${escapeHtml(item.key)}">REMOVE</button>
        </div>
        <strong class="hh-cart-item__price">${money(linePrice, cart.currency)}</strong>
      </article>`;
    }).join('');
  };

  const renderProgress = (cart) => {
    if (!cartDrawer) return;
    const threshold = Number(cartRules.freeShipping || 13000);
    const progressNode = cartDrawer.querySelector('[data-hh-cart-progress]');
    const copy = cartDrawer.querySelector('[data-hh-cart-progress-copy]');
    const track = cartDrawer.querySelector('.hh-cart-progress__track');
    const bar = cartDrawer.querySelector('[data-hh-cart-progress-bar]');
    const remaining = Math.max(0, threshold - Number(cart.total_price || 0));
    const progress = Math.min(100, Math.max(0, Number(cart.total_price || 0) / threshold * 100));
    if (copy) copy.textContent = remaining <= 0 ? 'FREE SHIPPING UNLOCKED ✓' : `${money(remaining, cart.currency)} AWAY FROM FREE SHIPPING`;
    if (bar) bar.style.width = `${progress}%`;
    if (progressNode) progressNode.classList.toggle('is-complete', remaining <= 0);
    if (track) track.setAttribute('aria-valuenow', String(Math.round(progress)));
  };

  const showUpsellCards = (group, inCart, limit = 4) => {
    if (!group) return 0;
    let shown = 0;
    group.querySelectorAll('[data-hh-upsell-product]').forEach((card) => {
      const hide = inCart.has(Number(card.dataset.productId)) || shown >= limit;
      card.hidden = hide;
      if (!hide) shown += 1;
    });
    return shown;
  };

  const renderUpsells = (cart) => {
    if (!cartDrawer) return;
    const section = cartDrawer.querySelector('[data-hh-cart-upsell]');
    const teeOffer = cartDrawer.querySelector('[data-hh-upsell-offer="tees"]');
    const hoodieOffer = cartDrawer.querySelector('[data-hh-upsell-offer="hoodies"]');
    const teeGroup = cartDrawer.querySelector('[data-hh-upsell-group="tees"]');
    const hoodieGroup = cartDrawer.querySelector('[data-hh-upsell-group="hoodies"]');
    const teeHeading = cartDrawer.querySelector('[data-hh-upsell-heading="tees"]');
    const hoodieHeading = cartDrawer.querySelector('[data-hh-upsell-heading="hoodies"]');
    const orNode = cartDrawer.querySelector('[data-hh-upsell-or]');
    if (!section) return;

    const total = Number(cart.total_price || 0);
    const threshold = Number(cartRules.freeShipping || 13000);
    if (!cart.item_count || total >= threshold) {
      section.hidden = true;
      return;
    }

    const teeQty = cart.items.reduce((sum, item) => sum + (teeIds.has(Number(item.product_id)) ? Number(item.quantity) : 0), 0);
    const hoodieQty = cart.items.reduce((sum, item) => sum + (hoodieIds.has(Number(item.product_id)) ? Number(item.quantity) : 0), 0);
    const inCart = new Set(cart.items.map((item) => Number(item.product_id)));
    const teeShown = showUpsellCards(teeGroup, inCart, 4);
    const hoodieShown = showUpsellCards(hoodieGroup, inCart, 4);

    if (teeHeading) teeHeading.textContent = teeQty === 1 ? 'ONE MORE TEE = 2 FOR $80' : '2 TEES FOR $80';
    if (hoodieHeading) hoodieHeading.textContent = hoodieQty === 1 ? 'ONE MORE HOODIE = 2 FOR $160' : 'ADD A HOODIE';
    if (teeOffer) teeOffer.hidden = teeShown === 0;
    if (hoodieOffer) hoodieOffer.hidden = hoodieShown === 0;
    if (orNode) orNode.hidden = teeShown === 0 || hoodieShown === 0;
    section.hidden = teeShown === 0 && hoodieShown === 0;
  };

  const renderCart = (cart) => {
    if (!cartDrawer) return;
    updateCartCount(cart);
    renderCartItems(cart);
    renderProgress(cart);
    renderUpsells(cart);
    const subtotal = cartDrawer.querySelector('[data-hh-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.total_price, cart.currency);
  };

  const refreshCart = async () => {
    if (!cartDrawer) return null;
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load cart');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  const openCart = async (doRefresh = true) => {
    if (!cartDrawer) return;
    closeMenu();
    cartLastFocus = document.activeElement;
    if (doRefresh) {
      try { await refreshCart(); } catch (e) {}
    }
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hh-drawer-open');
    const close = cartDrawer.querySelector('[data-hh-cart-close]');
    if (close) close.focus();
  };

  const closeCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hh-drawer-open');
    if (cartLastFocus && typeof cartLastFocus.focus === 'function') cartLastFocus.focus();
  };

  const changeCartLine = async (key, quantity) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity)) })
    });
    if (!response.ok) throw new Error('Could not update cart');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  const addVariant = async (variantId, quantity = 1) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) }] })
    });
    if (!response.ok) {
      let message = 'Could not add that item';
      try { const data = await response.json(); message = data.description || data.message || message; } catch (e) {}
      throw new Error(message);
    }
    return refreshCart();
  };

  document.addEventListener('click', async (event) => {
    const imageToggle = event.target.closest('[data-hh-image-toggle]');
    if (imageToggle) {
      event.preventDefault();
      const card = imageToggle.closest('.hh-product-card');
      if (!card) return;
      const isShowingAlt = card.classList.toggle('is-showing-alt');
      imageToggle.setAttribute('aria-pressed', String(isShowingAlt));
      return;
    }

    const menuOpen = event.target.closest('[data-hh-menu-open]');
    if (menuOpen) { event.preventDefault(); openMenu(); return; }
    const menuClose = event.target.closest('[data-hh-menu-close]');
    if (menuClose) { event.preventDefault(); closeMenu(); return; }

    const cartOpen = event.target.closest('[data-hh-cart-open]');
    if (cartOpen && cartDrawer) { event.preventDefault(); await openCart(true); return; }
    const cartClose = event.target.closest('[data-hh-cart-close]');
    if (cartClose) { event.preventDefault(); closeCart(); return; }

    const delta = event.target.closest('[data-hh-cart-delta]');
    if (delta) {
      event.preventDefault();
      delta.disabled = true;
      try { await changeCartLine(delta.dataset.key, Number(delta.dataset.quantity) + Number(delta.dataset.hhCartDelta)); }
      catch (e) { delta.disabled = false; }
      return;
    }

    const remove = event.target.closest('[data-hh-cart-remove]');
    if (remove) {
      event.preventDefault();
      remove.disabled = true;
      try { await changeCartLine(remove.dataset.key, 0); }
      catch (e) { remove.disabled = false; }
      return;
    }

    const upsellAdd = event.target.closest('[data-hh-upsell-add]');
    if (upsellAdd) {
      event.preventDefault();
      const card = upsellAdd.closest('[data-hh-upsell-product]');
      const variant = card && card.querySelector('[data-hh-upsell-variant]');
      if (!variant || !variant.value) return;
      const oldText = upsellAdd.textContent;
      upsellAdd.disabled = true;
      upsellAdd.textContent = 'ADDING...';
      try { await addVariant(variant.value, 1); }
      catch (e) { upsellAdd.textContent = 'TRY AGAIN'; setTimeout(() => { upsellAdd.textContent = oldText; upsellAdd.disabled = false; }, 1500); return; }
      upsellAdd.textContent = 'ADDED ✓';
      setTimeout(() => { upsellAdd.textContent = oldText; upsellAdd.disabled = false; }, 900);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCart();
    else if (menuDrawer && menuDrawer.classList.contains('is-open')) closeMenu();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-hh-product-form]');
    if (!form || !cartDrawer) return;
    const submitter = event.submitter;
    if (submitter && !submitter.matches('[data-hh-add]')) return;
    event.preventDefault();
    const button = form.querySelector('[data-hh-add]');
    const oldText = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'ADDING...'; }
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Could not add to cart');
      await refreshCart();
      if (button) button.textContent = 'ADDED ✓';
      await openCart(false);
      setTimeout(() => { updateVariantForm(form); }, 700);
    } catch (e) {
      if (button) { button.textContent = 'TRY AGAIN'; setTimeout(() => { button.textContent = oldText; button.disabled = false; }, 1400); }
    }
  });

  if (cartDrawer) refreshCart().catch(() => {});
})();

(() => {
  const init = () => {
    document.querySelectorAll('.hh-product__gallery').forEach((gallery, galleryIndex) => {
      if (gallery.closest('.hh-product__gallery-wrap')) return;
      const media = Array.from(gallery.querySelectorAll('.hh-product__media'));
      if (media.length < 2) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'hh-product__gallery-wrap';
      gallery.before(wrapper);
      wrapper.appendChild(gallery);
      gallery.id = gallery.id || 'HHGallery-' + galleryIndex;
      const controls = document.createElement('div');
      controls.className = 'hh-gallery-controls';
      const previous = document.createElement('button');
      previous.type = 'button';
      previous.textContent = '\u2190';
      previous.setAttribute('aria-label', 'Previous product photo');
      previous.setAttribute('aria-controls', gallery.id);
      const next = document.createElement('button');
      next.type = 'button';
      next.textContent = '\u2192';
      next.setAttribute('aria-label', 'Next product photo');
      next.setAttribute('aria-controls', gallery.id);
      const count = document.createElement('span');
      count.className = 'hh-gallery-count';
      count.setAttribute('aria-live', 'polite');
      count.setAttribute('aria-atomic', 'true');
      controls.append(previous, count, next);
      wrapper.appendChild(controls);
      const orderedMedia = () => media.slice().sort((a, b) => a.getBoundingClientRect().left - b.getBoundingClientRect().left);
      const currentIndex = (items) => {
        const left = gallery.getBoundingClientRect().left;
        return items.reduce((best, item, index) =>
          Math.abs(item.getBoundingClientRect().left - left) < Math.abs(items[best].getBoundingClientRect().left - left) ? index : best, 0);
      };
      const update = () => {
        const index = currentIndex(orderedMedia());
        const label = (index + 1) + ' / ' + media.length;
        if (count.textContent !== label) count.textContent = label;
        previous.disabled = index === 0;
        next.disabled = index === media.length - 1;
      };
      const move = (direction) => {
        const items = orderedMedia();
        const index = Math.max(0, Math.min(items.length - 1, currentIndex(items) + direction));
        const targetLeft = items[index].getBoundingClientRect().left - gallery.getBoundingClientRect().left + gallery.scrollLeft;
        gallery.scrollTo({ left: targetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      let frame = 0;
      const scheduleUpdate = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(() => { frame = 0; update(); });
      };
      gallery.addEventListener('scroll', scheduleUpdate, { passive: true });
      new MutationObserver(scheduleUpdate).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
      if (typeof ResizeObserver !== 'undefined') new ResizeObserver(scheduleUpdate).observe(gallery);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
